/*
 * @Author: keman.chen
 * @Date: 2023-08-14 15:05:01
 * @LastEditTime: 2024-01-04 20:11:18
 * @LastEditors: keman.chen
 * @Description: session management
 * @FilePath: /tlog-dashboard/Users/keman.chen/code/monitor/packages/core/src/session.ts
 */
import { generateUUID, getTimestamp } from '@tr-infra/pilot-utils'
class SessionManager {
  // session 有效时间 单位（毫秒）
  public expires: number = 1000 * 60 * 3 // 默认三分钟
  private sessionId = ''
  private startTime = 0

  setExpires(expires: number) {
    this.expires = expires
  }

  getSessionId() {
    const now = getTimestamp()
    if (!this.sessionId || now - this.startTime > this.expires) {
      this.startTime = now
      this.sessionId = generateUUID()
    }
    return this.sessionId
  }
}

export default new SessionManager()